var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:['mission-state-icon', _vm.layout, _vm.state]},[(_vm.state === 'pending')?_c('loading-indicator',{attrs:{"layout":_vm.layout}}):_vm._e(),_vm._v(" "),(_vm.state === 'cooldown')?_c('mission-clock'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }